import React from 'react';
import { Typography } from '@material-ui/core';

const ResponsiveDialogText: React.FC = ({ children }) => {
  return (
    <Typography variant="caption">
      {children}
    </Typography>
  )
}

export default ResponsiveDialogText;
